export default "__VITE_ASSET__D9ZSYBd3__";